import PagesInsertForm from "../../components/Pages/PagesInsertForm";




function PagesAdd(){


    return (
        <PagesInsertForm   ></PagesInsertForm>
    );
}
export default PagesAdd;